<section
  class="admin-blogs-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="admin-page-head">
    <div>
      <span class="admin-badge">إدارة المدونة</span>
      <h1>كل المقالات</h1>
      <p>تحكم في المقالات، عدّل المحتوى، غيّر الحالة، أو احذف المقالات.</p>
    </div>

    <button type="button" class="admin-refresh-btn" routerLink="/createblog">
      انشاء مقال
    </button>
    
  </div>

  <div class="admin-filters-card">
    <div class="filter-group">
      <label>بحث</label>
      <input
        type="text"
        placeholder="ابحث بعنوان المقال أو التصنيف أو الكلمات..."
        [value]="searchKeyword"
        (input)="onSearchInput($event)"
        (keyup.enter)="loadBlogs(1)"
      />
    </div>

    <div class="filter-group">
      <label>التصنيف</label>
      <select [value]="categoryFilter" (change)="onCategoryFilterChange($event)">
        <option value="">كل التصنيفات</option>
        <option value="career">المسار المهني</option>
        <option value="cv">السيرة الذاتية</option>
        <option value="travel">السفر</option>
        <option value="interview">المقابلات</option>
      </select>
    </div>

    <div class="filter-group">
      <label>الحالة</label>
      <select [value]="statusFilter" (change)="onStatusFilterChange($event)">
        <option value="">كل الحالات</option>
        <option value="published">منشور</option>
        <option value="draft">مسودة</option>
      </select>
    </div>

    <div class="filter-actions">
      <button type="button" class="primary-btn" (click)="loadBlogs(1)">
        بحث
      </button>

      <button type="button" class="secondary-btn" (click)="resetFilters()">
        إعادة ضبط
      </button>
    </div>
  </div>

  <div class="admin-table-card">
    <div class="table-top">
      <div>
        <h2>قائمة المقالات</h2>
        <p>الإجمالي: {{ total }}</p>
      </div>
    </div>

    <div class="admin-state" *ngIf="isLoading">
      جاري تحميل المقالات...
    </div>

    <div class="admin-state error" *ngIf="!isLoading && errorMessage">
      {{ errorMessage }}
    </div>

    <div
      class="admin-state empty"
      *ngIf="!isLoading && !errorMessage && blogs.length === 0"
    >
      لا توجد مقالات.
    </div>

    <div
      class="table-responsive"
      *ngIf="!isLoading && !errorMessage && blogs.length > 0"
    >
      <table class="admin-table">
        <thead>
          <tr>
            <th>المقال</th>
            <th>التصنيف</th>
            <th>الحالة</th>
            <th>مميز</th>
            <th>المشاهدات</th>
            <th>تاريخ النشر</th>
            <th class="actions-th">الإجراءات</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let blog of blogs; trackBy: trackByBlog">
            <td>
              <div class="blog-cell">
                <div class="blog-thumb" [class.has-image]="blog.imageUrl">
                  <img
                    *ngIf="blog.imageUrl"
                    [src]="blog.imageUrl"
                    [alt]="displayTitle(blog)"
                    loading="lazy"
                    (error)="onBlogImageError(blog)"
                  />

                  <span *ngIf="!blog.imageUrl">
                    {{ getBlogIcon(blog) }}
                  </span>
                </div>

                <div>
                  <strong>{{ displayTitle(blog) }}</strong>
                  <small>رقم: {{ blog.id }}</small>
                  <p>{{ displayExcerpt(blog) }}</p>
                </div>
              </div>
            </td>

            <td>
              <span class="type-badge">
                {{ getCategoryLabel(blog.category) }}
              </span>
            </td>

            <td>
              <select
                class="status-select"
                [class.published]="blog.status === 'published'"
                [class.draft]="blog.status === 'draft'"
                [value]="blog.status"
                [disabled]="isChangingStatusId === blog.id"
                (change)="changeStatus(blog, $event)"
              >
                <option value="published">منشور</option>
                <option value="draft">مسودة</option>
              </select>
            </td>

            <td>
              <button
                type="button"
                class="featured-btn"
                [class.active]="blog.isFeatured"
                [disabled]="isChangingStatusId === blog.id"
                (click)="toggleFeatured(blog)"
              >
                {{ blog.isFeatured ? 'نعم' : 'لا' }}
              </button>
            </td>

            <td>
              {{ blog.viewsCount }}
            </td>

            <td>
              {{ formatDate(blog.publishedAt) }}
            </td>

            <td>
              <div class="table-actions">
                <button type="button" class="edit-btn" (click)="openEditModal(blog)">
                  تعديل
                </button>

                <button
                  type="button"
                  class="delete-btn"
                  [disabled]="isDeletingId === blog.id"
                  (click)="deleteBlog(blog)"
                >
                  {{ isDeletingId === blog.id ? 'جاري الحذف...' : 'حذف' }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="pagination"
      *ngIf="!isLoading && !errorMessage && blogs.length > 0 && lastPage > 1"
    >
      <button
        type="button"
        [disabled]="page <= 1"
        (click)="loadBlogs(page - 1)"
      >
        السابق
      </button>

      <button
        type="button"
        *ngFor="let item of pages"
        [class.active]="page === item"
        (click)="loadBlogs(item)"
      >
        {{ item }}
      </button>

      <button
        type="button"
        [disabled]="page >= lastPage"
        (click)="loadBlogs(page + 1)"
      >
        التالي
      </button>
    </div>
  </div>
</section>

<div class="admin-modal-backdrop" *ngIf="showEditModal">
  <div class="admin-modal" [class.is-rtl]="isAr" [attr.dir]="isAr ? 'rtl' : 'ltr'">
    <div class="modal-head">
      <div>
        <h2>تعديل المقال</h2>
        <p>عدّل بيانات المقال ثم احفظ التغييرات.</p>
      </div>

      <button type="button" class="modal-close" (click)="closeEditModal()">
        ×
      </button>
    </div>

    <div class="admin-state" *ngIf="isLoadingDetails">
      جاري تحميل محتوى المقال...
    </div>

    <form [formGroup]="blogForm" (ngSubmit)="submitEdit()">
      <div class="modal-grid">
        <label>
          <span>العنوان بالإنجليزي</span>
          <input type="text" formControlName="title_en" />
        </label>

        <label>
          <span>العنوان بالعربي</span>
          <input type="text" formControlName="title_ar" />
        </label>

        <label>
          <span>Slug</span>
          <input type="text" formControlName="slug" />
        </label>

        <label>
          <span>التصنيف</span>
          <select formControlName="category">
            <option value="career">المسار المهني</option>
            <option value="cv">السيرة الذاتية</option>
            <option value="travel">السفر</option>
            <option value="interview">المقابلات</option>
          </select>
        </label>

        <label>
          <span>اسم التصنيف بالإنجليزي</span>
          <input type="text" formControlName="category_en" />
        </label>

        <label>
          <span>اسم التصنيف بالعربي</span>
          <input type="text" formControlName="category_ar" />
        </label>

        <label>
          <span>الأيقونة</span>
          <input type="text" formControlName="icon" placeholder="مثال: 📄" />
        </label>

        <label>
          <span>تاريخ النشر</span>
          <input type="date" formControlName="published_at" />
        </label>

        <label>
          <span>وقت القراءة بالإنجليزي</span>
          <input type="text" formControlName="read_time_en" />
        </label>

        <label>
          <span>وقت القراءة بالعربي</span>
          <input type="text" formControlName="read_time_ar" />
        </label>

        <label>
          <span>الحالة</span>
          <select formControlName="status">
            <option value="published">منشور</option>
            <option value="draft">مسودة</option>
          </select>
        </label>

        <label class="checkbox-label">
          <input type="checkbox" formControlName="is_featured" />
          <span>مقال مميز</span>
        </label>

        <label class="full image-upload-label">
          <span>صورة المقال</span>

          <div class="image-upload-box">
            <div class="image-preview" *ngIf="imagePreviewUrl">
              <img [src]="imagePreviewUrl" alt="Blog image" />
            </div>

            <div class="image-placeholder" *ngIf="!imagePreviewUrl">
              اختر صورة للمقال
            </div>

            <input
              type="file"
              accept="image/*"
              (change)="onImageSelected($event)"
            />
          </div>

          <button
            type="button"
            class="secondary-btn remove-image-btn"
            *ngIf="selectedImageFile"
            (click)="removeSelectedImage()"
          >
            إلغاء الصورة الجديدة
          </button>
        </label>

        <label class="full">
          <span>الملخص بالإنجليزي</span>
          <textarea rows="3" formControlName="excerpt_en"></textarea>
        </label>

        <label class="full">
          <span>الملخص بالعربي</span>
          <textarea rows="3" formControlName="excerpt_ar"></textarea>
        </label>

        <label class="full">
          <span>المحتوى بالإنجليزي HTML</span>
          <textarea rows="6" formControlName="content_en"></textarea>
        </label>

        <label class="full">
          <span>المحتوى بالعربي HTML</span>
          <textarea rows="6" formControlName="content_ar"></textarea>
        </label>

        <label>
          <span>Tags بالإنجليزي</span>
          <input type="text" formControlName="tags_en" placeholder="CV, Jobs, Tips" />
        </label>

        <label>
          <span>Tags بالعربي</span>
          <input
            type="text"
            formControlName="tags_ar"
            placeholder="السيرة الذاتية, الوظائف"
          />
        </label>

        <label>
          <span>Meta Title بالإنجليزي</span>
          <input type="text" formControlName="meta_title_en" />
        </label>

        <label>
          <span>Meta Title بالعربي</span>
          <input type="text" formControlName="meta_title_ar" />
        </label>

        <label class="full">
          <span>Meta Description بالإنجليزي</span>
          <textarea rows="3" formControlName="meta_description_en"></textarea>
        </label>

        <label class="full">
          <span>Meta Description بالعربي</span>
          <textarea rows="3" formControlName="meta_description_ar"></textarea>
        </label>
      </div>

      <div class="modal-actions">
        <button type="button" class="secondary-btn" (click)="closeEditModal()">
          إلغاء
        </button>

        <button type="submit" class="primary-btn" [disabled]="isSaving">
          {{ isSaving ? 'جاري الحفظ...' : 'حفظ التغييرات' }}
        </button>
      </div>
    </form>
  </div>
</div>